module.exports = __webpack_public_path__ + "img/2.d6660f60.svg";